// src/pages/StartPortfolio.js

import React from 'react';

export default function StartPortfolio({ onCreate, onLogin }) {
  return (
    <div style={{ padding: '1rem', textAlign: 'center' }}>
      <h1>Your Creative Dashboard</h1>
      <p>Create your portfolio</p>
      <p>Manage your portfolio</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <button
          onClick={onCreate}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Create New Portfolio
        </button>

        <button
          onClick={onLogin}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Visit Your Portfolio
        </button>
      </div>
    </div>
  );
}
